import { render, staticRenderFns } from "./logical-tree.vue?vue&type=template&id=3d1e788f&scoped=true"
import script from "./logical-tree.vue?vue&type=script&lang=ts"
export * from "./logical-tree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1e788f",
  null
  
)

export default component.exports